











import { Component, Vue } from 'vue-property-decorator';
import SolutionForm from './components/solutionForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { solutionListInstance } from '@/model/SolutionListClass';

type IUpdateQuotationParams = ISolution.IRequest.IUpdateQuotationParams;
type IClauseOption = ISolution.IClauseOption;

@Component({
  components: {
    SolutionForm,
  },
})
export default class CreateSolution extends Vue {
  private solutionListInstance = solutionListInstance;
  get solutionInfoForCreate() {
    const result = this.solutionListInstance.solutionForCreate;
    if (result) {
      return result;
    }
    return this.solutionListInstance.createSolution();
  }
  get requireClauses(): IClauseOption[] {
    return this.solutionListInstance.requireClauses;
  }
  private created() {
    solutionListInstance.requestCategorys();
  }
  private createSolution(params: IUpdateQuotationParams): Promise<string> {
    return new Promise((reslove, reject) => {
      this.solutionListInstance
        .requestCreateItem(params)
        .then((res) => {
          reslove(res);
          this.goListPage();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({ name: 'Solution' });
  }
}
